import _ from 'underscore';
import { addColumnOnLevel } from '../add-column-on-level';
import callStatusTemplate from './callstatus-template.pug';
import timeTemplate from './time-template.pug';

// inject via arg
// import i18n from '$/i18n!global';
// import { bingadsGridColumn } from 'component/bingads-grid/shared/column';

export function getCallForwardingGridColumnConfig({
  i18n,
  bingadsGridColumn,
}) {
  function column(options) {
    return bingadsGridColumn(_.defaults({}, options, { i18n }));
  }

  return {
    getLevelOfDetailColumns: (level) => {
      const levelOfDetailColumns = [];

      levelOfDetailColumns.push(column({
        name: 'StartTime',
        title: 'ColumnName_StartTime',
        property: {
          get(row) {
            const time = new Date(row.StartTime);

            return {
              date: `${time.toLocaleDateString()} ${time.toLocaleTimeString()}`,
            };
          },
          key: 'StartTime',
        },
        template: timeTemplate,
        sortable: true,
        type: 'datetime',
        helpId: 'Pop_BA_Reporting_Clarity_CallStartTime',
      }));
      levelOfDetailColumns.push(column({
        name: 'EndTime',
        title: 'ColumnName_EndTime',
        sortable: true,
        property: {
          get(row) {
            const time = new Date(row.EndTime);

            return {
              date: `${time.toLocaleDateString()} ${time.toLocaleTimeString()}`,
            };
          },
          key: 'EndTime',
        },
        type: 'datetime',
        template: timeTemplate,
        helpId: 'Pop_BA_Reporting_Clarity_CallEndTime',
      }));
      levelOfDetailColumns.push(column({
        name: 'AreaCode',
        title: 'ColumnName_AreaCode',
        sortable: true,
        type: 'string',
        helpId: 'pop_BA_Reporting_Clarity_AreaCode',
      }));
      levelOfDetailColumns.push(column({
        name: 'City',
        title: 'ColumnName_City',
        sortable: true,
        type: 'string',
        helpId: 'pop_BA_Reporting_Clarity_CityLocation',
      }));
      levelOfDetailColumns.push(column({
        name: 'StateOrProvince',
        title: 'ColumnName_StateOrProvince',
        sortable: true,
        type: 'string',
        helpId: 'pop_BA_Reporting_Clarity_StatePhysical',
      }));
      levelOfDetailColumns.push(column({
        name: 'CallStatus',
        title: 'ColumnName_CallStatus',
        sortable: true,
        type: 'integer',
        property: {
          get(row) {
            let callStatus = null;

            switch (row.CallStatus) {
              case 0:
                callStatus = i18n.getString('Dimension_CallStatus_0');
                break;
              case 1:
                callStatus = i18n.getString('Dimension_CallStatus_1');
                break;
              default:
                break;
            }

            return {
              callStatus,
            };
          },
          key: 'CallStatus',
        },
        template: callStatusTemplate,
        helpId: 'pop_BA_Reporting_Clarity_CallStatus',
      }));

      addColumnOnLevel(column, levelOfDetailColumns, level);

      return levelOfDetailColumns;
    },
    getPerfColumns: () => [
      column({
        name: 'CallDuration',
        title: 'ColumnName_CallDuration',
        sortable: true,
        type: 'integer',
        helpId: 'pop_BA_Reporting_Clarity_Duration',
      }),
    ],
  };
}
